import { AspectRatio, Box, Stack, Text, VStack } from "@chakra-ui/react";
import { useContaxt } from "../../context/Context";
import { WhatsAppAudio } from "../landing-pages/funnel-components/whatsapp-audio/WhatsAppAudio";

export function ContentCard({
  href,
  image,
  alt,
  title,
  linkTitle,
  text,
  backgroundColor,
  color,
  audio,
  audioImage,
  contentHeight,
  aspectRatio = 16 / 9,
}) {
  const { variant } = useContaxt();

  const ContentCardImage = () => {
    return (
      <AspectRatio ratio={aspectRatio} w="100%">
        <img
          style={{
            borderRadius: "25px 25px 0px 0px",
            width: "100%",
            height: "100%",
            maxHeight: variant === "base" ? "305px" : "160px",
            objectFit: "cover",
            display: "block",
          }}
          src={image}
          alt={alt}
          title={alt}
          loading="lazy"
          decoding="async"
        />
      </AspectRatio>
    );
  };

  return (
    <Stack
      spacing={0}
      w={variant === "base" ? "90vw" : audio ? "270px" : "200px"}
    >
      {href ? (
        <a href={href} title={linkTitle} rel={"nofollow"} target="_blank">
          <ContentCardImage />
        </a>
      ) : (
        <ContentCardImage />
      )}

      <VStack
        textAlign={"center"}
        w={"100%"}
        h={contentHeight ?? "100px"}
        borderBottomRadius={"25px"}
        backgroundColor={backgroundColor ?? "white"}
        color={color}
      >
        <Text pt={"10px"} fontSize={"20px"} fontWeight={"black"}>
          {title}
        </Text>
        <Text fontWeight={"hairline"}>{text}</Text>
        {audio && (
          <Box px={3}>
            <WhatsAppAudio
              borderRadius={"15px"}
              minWidth={variant === "base" ? "85vw" : "250px"}
              image={audioImage}
              audio={audio}
            />
          </Box>
        )}
      </VStack>
    </Stack>
  );
}
